import axios from '@/libs/api.request'

export const getRecommendList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/recommend'
  })
}

export const addRecommend = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/recommend'
  })
}

export const editRecommend = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/recommend'
  })
}

export const delRecommend = (id) => {
  return axios.request({
    method: 'delete',
    url: '/recommend/' + id
  })
}

export const getRecommendInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/recommend/' + id
  })
}

export const getRecommendPlay = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/recommend/play'
  })
}

export const addRecommendPlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/recommend/play'
  })
}

export const editRecommendPlay = (params) => {
  return axios.request({
    method: 'put',
    params,
    url: '/recommend/play'
  })
}

export const delRecommendPlay = (id) => {
  return axios.request({
    method: 'delete',
    url: '/recommend/play/' + id
  })
}

export const getRecommendPlayNotIn = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/recommend/play/notIn'
  })
}
